import React, { useEffect, useState } from 'react';
import ReadMoreText from '../ReadMoreText';
import { useUser } from '../../auth/UseUser';
import { getCourseDayById } from '../../server/server';
import Loading from '../Loading';
import CreateDayContentModal from './CreateDayContentModal';
import MDEditor from '@uiw/react-md-editor';
import { fileSystemUrl } from '../../server/connections';
import { FaEdit } from 'react-icons/fa';

function CourseDayEditing({ days, setDays, currentDay, course }: { days: any; setDays: any; currentDay: any; course: any }) {
	const { user, setUser } = useUser();
	const [day, setDay] = useState<any>(null);
	const [loading, setLoading] = useState(false);
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		if (currentDay !== -1 && !!days[currentDay]?.id) loadDay(days[currentDay]?.id);
		else {
			setDay(null);
			openCreateJournalContent();
		}
	}, [currentDay]);

	const loadDay = async (id: string) => {
		setLoading(true);
		const resp = await getCourseDayById(id);
		if (resp.status == 200) {
			setDay(resp.data);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const closeCreateDayContent = () => {
		setModalIsOpen(false);
	};
	const openCreateJournalContent = () => {
		setModalIsOpen(true);
	};

	const reloadDay = (id: string) => {
		const elementId = days.find((element: any) => !element.hasOwnProperty('id'));
		if (elementId) {
			var newList = [...days];
			newList[currentDay] = { ...newList[currentDay], id: id };
			setDays(newList);
		}
		loadDay(id);
	};

	return (
		<div className=' mt-4 '>
			{loading ? (
				<div className='w-full flex flex-row items-center justify-center min-h-[300px]'>
					<Loading size={70} primaryColor='#5E639B' stroke={3} />
				</div>
			) : (
				<div className={`bg-containerGray rounded-xl p-6 flex flex-row  gap-6 relative mb-5 xl:mb-0 flex-1`}>
					<div className='flex-1'>
						{day?.wisdomTitle && (
							<div className='flex flex-col w-full'>
								<div className='flex flex-col justify-start '>
									<div className='flex flex-row  '>
										<p className='text-left font-bold text-primaryViolet text-base text-nowrap'>Wisdom title:&nbsp; </p>
										<MDEditor.Markdown className=' bg-containerGray ' style={{ color: '#5E639B', backgroundColor: 'rgb(248 248 251)' }} source={day?.wisdomTitle} />
									</div>
									<div className='flex flex-row '>
										<p className='text-left font-bold text-primaryViolet text-base text-nowrap'>Wisdom text:&nbsp; </p>
										<MDEditor.Markdown className=' bg-containerGray ' style={{ color: '#5E639B', backgroundColor: 'rgb(248 248 251)' }} source={day?.wisdomText} />
									</div>
									<div id='dot-line-program'></div>
								</div>
								<div className='flex flex-col justify-start '>
									<div className='flex flex-row  '>
										<p className='text-left font-bold text-primaryViolet text-base'>Text:&nbsp; </p>
										<MDEditor.Markdown className=' bg-containerGray ' style={{ color: '#5E639B', backgroundColor: 'rgb(248 248 251)' }} source={day?.text} />
									</div>
									<div className='flex flex-row  '>
										<p className='text-left font-bold text-primaryViolet text-base text-nowrap'>Challenge:&nbsp; </p>
										<MDEditor.Markdown className=' bg-containerGray ' style={{ color: '#5E639B', backgroundColor: 'rgb(248 248 251)' }} source={day?.challenge} />
									</div>
									<div id='dot-line-program'></div>
								</div>
								<div className='flex flex-col justify-start '>
									<div className='flex flex-row  '>
										<p className='text-left font-bold text-primaryViolet text-base'>Reflection:&nbsp; {day?.reflectionQuestion}</p>
									</div>
									<div className='flex flex-row items-center '>
										<p className='text-left font-bold text-primaryViolet text-base'>Audio title:&nbsp;{day?.audioTitle} </p>
									</div>

									<div id='dot-line-program'></div>
								</div>
								{!!day?.audio && (
									<div className='mt-2'>
										<audio controls>
											<source src={fileSystemUrl + '/' + day?.audio?.url} type='audio/mp3' />
											Vaš pretraživač ne podržava reprodukciju zvuka.
										</audio>
									</div>
								)}
							</div>
						)}
					</div>
					<div className='flex flex-col flex-1 max-w-[250px]'>
						<div className='flex flex-row justify-end  mb-3'>
							<div className='px-2 h-[40px] cursor-pointer text-primaryViolet flex items-center justify-center' onClick={() => openCreateJournalContent()}>
								<FaEdit style={{ width: 20, height: 20 }} />
							</div>
						</div>
						{!!day?.icon && (
							<div className='w-full rounded-xl'>
								<img style={{ objectFit: 'contain', width: '100%', minHeight: 170, marginTop: 10 }} src={fileSystemUrl + '/' + day.icon.url} alt='' />
							</div>
						)}
					</div>
				</div>
			)}
			<CreateDayContentModal modalIsOpen={modalIsOpen} closeModal={closeCreateDayContent} content={day} index={currentDay} course={course} reloadDay={reloadDay} />
		</div>
	);
}

export default CourseDayEditing;
